import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function StaffPickTag(props: { className?: string }) {
  return (
    <span
      className={twMerge(
        'px-1 mr-1 text-xs font-semibold text-white bg-pink-700 rounded whitespace-nowrap',
        props.className
      )}
    >
      STAFF PICK
    </span>
  );
}
